// components
import Link from 'next/link';
import { Button } from '@/components/ui/button';
import { Icon } from '@/components/ui/icon';
import VisibleLoading from '@/components/utilities/VisibleLoading';

const TextBlock = ({ title, text, buttons, textBlockVariant: variant }) => {
  return (
    <div className="max-w-[496px] text-left">
      <VisibleLoading delay={75}>
        {({ ref, className }) => (
          <h2 ref={ref} className={className}>
            {title}
          </h2>
        )}
      </VisibleLoading>

      {text && (
        <VisibleLoading delay={150}>
          {({ ref, className }) => (
            <div
              ref={ref}
              className={`txt-lg mt-6 whitespace-pre-wrap ${variant === 'light' ? 'text-grey-700' : 'text-white-75'} ${className || ''}`.trim()}
            >
              {text}
            </div>
          )}
        </VisibleLoading>
      )}

      {buttons && buttons.length > 0 && (
        <div className="mt-8 flex flex-wrap gap-4">
          {buttons.map((button, index) => (
            <VisibleLoading key={button.id} delay={(index + 1) * 200}>
              {({ ref, className }) => (
                <Button
                  ref={ref}
                  key={button.id}
                  variant={button.variant}
                  size={button.size}
                  asChild={true}
                  className={`basis-full xl:basis-auto ${className || ''}`.trim()}
                >
                  <Link href={button.url || ''}>
                    {button.label} <Icon type={button.icon} />
                  </Link>
                </Button>
              )}
            </VisibleLoading>
          ))}
        </div>
      )}
    </div>
  );
};
export default TextBlock;
